/**
 * SnackbarItem.jsx
 *
 * @Author: jruif
 * @Date: 2018/1/17 上午9:48
 */

import React, { isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EventListener from 'react-event-listener';
// import Icon from '../icon';
import Close from '../icons/internals/Close';
import statusIcons from '../icons/statusIcons';
import IconButton from '../button/IconButton';

/**
 * SnackbarItem
 * */
class SnackbarItem extends React.PureComponent {
  static displayName = 'NeatUI.SnackbarItem';

  static propTypes = {
    /**
     * 默认 5 秒后自动关闭，配置为 0 时则不自动关闭
     * */
    autoHideDuration: PropTypes.number,
    /**
     * 需要显示的内容，接受的类型是PropTypes.node，即下列类型均可渲染: numbers, strings, elements 或一个 array
     * */
    content: PropTypes.node.isRequired,
    /**
     * 自定义行为按钮，必须返回Element
     * */
    actionsRender: PropTypes.func,

    /**
     * 关闭时回调
     * */
    onClose: PropTypes.func,
    /**
     * 类型
     * */
    type: PropTypes.oneOf(['info', 'error', 'warning', 'success', 'none']),
    /**
     * 是否显示close按钮
     * */
    hideCloseButton: PropTypes.bool,
    /**
     * icon类型, 同Icon
     * */
    icon: PropTypes.node,
    type: PropTypes.oneOf(['primary', 'success', 'warning', 'info', 'error']),
  };

  static defaultProps = {
    autoHideDuration: 5000,
    prefixCls: 'ne-snackbar-item',
    showClose: true,
    type: 'primary',
    hideCloseButton: false,
  };

  componentDidMount() {
    this.startTimeout();
  }

  componentWillUnmount() {
    this.clearTimeout();
  }

  setTimer = duration => {
    this.timer = setTimeout(this.close, duration);
  };

  restartTimeout = () => {
    const { autoHideDuration } = this.props;
    if (autoHideDuration > 0) {
      this.setTimer(autoHideDuration * 0.5);
    }
  };

  startTimeout = () => {
    const { autoHideDuration } = this.props;
    if (autoHideDuration > 0) {
      this.setTimer(autoHideDuration);
    }
  };

  clearTimeout = () => {
    clearTimeout(this.timer);
  };

  close = e => {
    const { onClose, id } = this.props;
    onClose && onClose(id, e ? 'click' : 'timeout');
    this.clearTimeout();
  };

  handleMouseEnter = e => {
    const { onMouseEnter } = this.props;
    if (onMouseEnter) {
      onMouseEnter(e);
    }
    this.clearTimeout();
  };

  handleMouseLeave = e => {
    const { onMouseLeave } = this.props;
    if (onMouseLeave) {
      onMouseLeave(e);
    }
    this.restartTimeout();
  };

  render() {
    const {
      prefixCls,
      className,
      children,
      content,
      actionsRender,
      style,
      hideCloseButton,
      title,
      icon,
      disableWindowBlurListener,
      id,
      type,
    } = this.props;
    const classes = classNames(prefixCls, `${prefixCls}-color-${type}`, className);
    const StatusIcon = statusIcons[type];
    return (
      <div
        className={classes}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        style={Object.assign({ zIndex: id }, style)}>
        <EventListener
          target="window"
          onFocus={disableWindowBlurListener ? undefined : this.restartTimeout}
          onBlur={disableWindowBlurListener ? undefined : this.clearTimeout}/>
        <div className={`${prefixCls}-body`}>
          <div
            className={classNames(`${prefixCls}-content-container`, {
              [`${prefixCls}-content-container-full-width`]: title,
            })}>
            {icon && isValidElement(icon) ? (
              cloneElement(icon, {
                className: classNames(`${prefixCls}-icon`, icon.props.className),
              })
            ) : StatusIcon ? (
              <StatusIcon className={`${prefixCls}-icon`} />
            ) : null}
            <div className={`${prefixCls}-wrapper`}>
              {title ? <h6 className={`${prefixCls}-title`}>{title}</h6> : null}
              <div className={`${prefixCls}-description`}>{content || children}</div>
            </div>
          </div>
          {actionsRender ? (
            <div className={`${prefixCls}-actions`}>{actionsRender(this.close)}</div>
          ) : null}
          {hideCloseButton ? null : (
            <IconButton
              className={classNames(`${prefixCls}-close`)}
              size="small"
              variant={type === 'primary' ? 'hollow' : 'text'}
              shape="borderless"
              onClick={this.close}>
              <Close />
            </IconButton>
          )}
        </div>
      </div>
    );
  }
}

export default SnackbarItem;



// WEBPACK FOOTER //
// ./src/snackbar/SnackbarItem.jsx